<app-demo-and-proofs [showNotes]="true">
  <app-action-icons></app-action-icons>
</app-demo-and-proofs>
